"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.sourceFragmentDependencies, fragments_1.sourceFragment];
const MUTATION = `
mutation createSource(
  $name: String!
  $blockchainAddress: String!
  $type: SourceType!
) {
  createSource(
    createSourceInput: {
      name: $name
      blockchainAddress: $blockchainAddress
      type: $type
    }
  ) {
    ...sourceFragment
  }
}
`.trim();
const createSourceImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'createSource');
exports.default = createSourceImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlU291cmNlSW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9tdXRhdGlvbnMvY3JlYXRlU291cmNlSW1wbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDRDQUEwRTtBQUMxRSwyRUFHNEM7QUFNNUMsTUFBTSxZQUFZLEdBQUcsQ0FBQyxHQUFHLHNDQUEwQixFQUFFLDBCQUFjLENBQUMsQ0FBQztBQUVyRSxNQUFNLFFBQVEsR0FBRzs7Ozs7Ozs7Ozs7Ozs7OztDQWdCaEIsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVULE1BQU0sZ0JBQWdCLEdBQUcsSUFBQSxnQ0FBVyxFQUNsQyxJQUFBLHdDQUFtQixFQUFDLEdBQUcsWUFBWSxFQUFFLFFBQVEsQ0FBQyxFQUM5QyxjQUFjLENBQ2YsQ0FBQztBQUVGLGtCQUFlLGdCQUFnQixDQUFDIn0=